import { render, staticRenderFns } from "./SubAdmins.vue?vue&type=template&id=183df71a&scoped=true&"
import script from "./SubAdmins.vue?vue&type=script&lang=js&"
export * from "./SubAdmins.vue?vue&type=script&lang=js&"
import style0 from "./SubAdmins.vue?vue&type=style&index=0&id=183df71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183df71a",
  null
  
)

export default component.exports